var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app--body"},[(_vm.$route.name === 'Home')?_c('app-title',[_vm._v("Find Your Lesson")]):_vm._e(),_c('router-view')],1),_c('div',{staticClass:"app--bottom-nav"},[_c('app-bottom-nav')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }